import { useEffect } from 'react'

import {
  DelayedOperationController,
  useDelayedOperationContext,
} from 'core-components/library/delayedOperationController'

import { IAsyncTabButtonsProps } from '../models/IAsyncTabButtons'

import { BaseTabButtons } from './base/BaseTabButtons'

export const AsyncTabButtons = (props: IAsyncTabButtonsProps) => {
  return (
    <DelayedOperationController>
      <TabButtonsComponent {...props} />
    </DelayedOperationController>
  )
}

const TabButtonsComponent = (props: IAsyncTabButtonsProps) => {
  const { delayedOperation } = props
  const { addOperation, finishOperations, finishOperationsInProgress } =
    useDelayedOperationContext()

  const urlKeyHandler = async () => {
    await finishOperations()
  }

  useEffect(() => {
    return addOperation(delayedOperation)
  }, [addOperation, delayedOperation])

  return (
    <BaseTabButtons
      urlKeyHandler={urlKeyHandler}
      isTabChangeDisabled={finishOperationsInProgress}
      additionalHeaderProps={{ tabLoaderVisible: finishOperationsInProgress }}
      {...props}
    />
  )
}
